import Controller from '@philips-internal/oswald-ui-core/lib/client';

import BaseController from '../BaseController';
import { Inject } from '@odinjs/odin';
import type { LayoutAPI } from '@philips-internal/oswald-ui-components';
import { FragmentNames, MealDeliveryAliases } from '../../codegen';

@Controller ({ component: MealDeliveryAliases.MEAL_DELIVERY_LAYOUT, fragment: FragmentNames.MEAL_DELIVERY })
export default class MealDeliveryController extends BaseController {
  @Inject(MealDeliveryAliases.MEAL_DELIVERY_LAYOUT)
  declare mealDeliveryLayout: LayoutAPI;
}
